import { KitRequestSchema } from 'types/kitting';

export const customerManagesOwnWarehouse = (
  kitRequest: Pick<KitRequestSchema, 'sourceLocations' | 'org'>
) =>
  kitRequest.sourceLocations.every(
    (location) => location.org === kitRequest.org.id
  );

export const canUnapproveKitRequest = (
  kitRequest: Pick<
    KitRequestSchema,
    'approved' | 'fulfilledAt' | 'sourceLocations' | 'org'
  >,
  isCofactr: boolean
) => {
  if (isCofactr) return kitRequest.approved;
  return (
    kitRequest.approved &&
    !kitRequest.fulfilledAt &&
    customerManagesOwnWarehouse(kitRequest)
  );
};

export const canApproveKitRequest = (
  kitRequest: Pick<KitRequestSchema, 'approved'>,
  hasLines: boolean
) => !kitRequest.approved && hasLines;

export const canDeleteKitRequest = (
  kitRequest: Pick<
    KitRequestSchema,
    'approved' | 'voidedAt' | 'fulfilledAt' | 'archived'
  >
) =>
  !(
    kitRequest.approved ||
    kitRequest.voidedAt ||
    kitRequest.fulfilledAt ||
    kitRequest.archived
  );
